import DisplayPart from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/options/components/OptionsDisplayPart';
import FormPart from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/options/components/OptionsFormPart';

const exported = {
  DisplayPart,
  FormPart,
};

export default exported;
export { DisplayPart, FormPart };
